import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faBold } from "@fortawesome/free-solid-svg-icons"

export const Bold = (props) => {
  return <FontAwesomeIcon faIcon={faBold} {...props} />
}
